// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 5: प्रारंभिक चर्च
// ============================================================================
// स्तर 53-65 (13 स्तर, 39 प्रश्न)

export const chapter5Translations = {
  name: "प्रारंभिक चर्च",
  description: "तुम शक्ति प्राप्त करोगे...",
  
  spiritualWisdom: {
    principle: "पवित्र आत्मा गवाही देने के लिए शक्ति और साहस देता है",
    scripture: "परन्तु जब पवित्र आत्मा तुम पर आएगा तब तुम सामर्थ पाओगे; और मेरे गवाह होगे (प्रेरितों के काम 1:8)",
    application: "चर्च आत्मा की आग में जन्म लेता है और साहसी गवाही से बढ़ता है"
  },
  
  levels: {
    53: {
      name: "स्वर्गारोहण",
      challenge: "तुम मेरे गवाह होगे... पृथ्वी की छोर तक...",
      easy: {
        question: "अपने पुनरुत्थान के कितने दिन बाद यीशु स्वर्ग में चढ़े?",
        options: ["30 दिन", "40 दिन", "50 दिन", "60 दिन"],
        hint: "तैयारी की बाइबिल संख्या",
        funFact: "☁️ विश्वव्यापी मिशन से पहले 40 दिनों की गहन शिक्षा!"
      },
      medium: {
        question: "स्वर्ग में चढ़ने से पहले यीशु क्या वादा करते हैं?",
        options: [
          "वह जल्द लौटेंगे",
          "वह पवित्र आत्मा को सामर्थ के साथ भेजेंगे",
          "वह एक चर्च बनाएंगे",
          "वह दुष्टों को दण्ड देंगे"
        ],
        hint: "ऊपर से एक शक्ति",
        funFact: "⚡ पवित्र आत्मा का वादा - भयभीत शिष्यों का परिवर्तन!"
      },
      hard: {
        question: "स्वर्गारोहण हमारे आध्यात्मिक जीवन में क्या प्रतीक है?",
        options: [
          "यीशु की उपस्थिति का अंत",
          "यीशु राज करते हैं और स्वर्ग में हमारे लिए मध्यस्थता करते हैं",
          "एक अंतिम अलगाव",
          "एक प्रतीकात्मक मिथक"
        ],
        hint: "यह उनकी महिमामय और सक्रिय उपस्थिति के बारे में है",
        funFact: "👑 यीशु परमेश्वर के दाहिने हाथ राज करते हैं और हमारे लिए मध्यस्थता करते हैं!"
      }
    },
    
    54: {
      name: "पेन्तेकुस्त",
      challenge: "वे सब पवित्र आत्मा से भर गए और बोलने लगे...",
      easy: {
        question: "स्वर्गारोहण के कितने दिन बाद पेन्तेकुस्त हुआ?",
        options: ["7 दिन", "10 दिन", "14 दिन", "20 दिन"],
        hint: "लगभग दस दिन",
        funFact: "🔟 10 दिनों की गहन प्रार्थना आत्मा के उण्डेले जाने की तैयारी करती है!"
      },
      medium: {
        question: "पवित्र आत्मा किस रूप में प्रकट हुआ?",
        options: [
          "प्रचण्ड वायु की तरह",
          "आग की लपटों की तरह",
          "कबूतर की तरह",
          "प्रकाश की तरह"
        ],
        hint: "ज्वालाएं जो प्रत्येक शिष्य पर ठहरती हैं",
        funFact: "🔥 आग की लपटें: आत्मा साहस और भाषाओं का वरदान देता है!"
      },
      hard: {
        question: "पेन्तेकुस्त सार्वभौमिक चर्च के लिए क्या प्रतिनिधित्व करता है?",
        options: [
          "एक अलग ऐतिहासिक घटना",
          "मिशनरी चर्च का आधिकारिक जन्म",
          "जिज्ञासा का चमत्कार",
          "उत्सव की शुरुआत"
        ],
        hint: "यह चर्च के जन्म प्रमाण पत्र के बारे में है",
        funFact: "🎂 पेन्तेकुस्त = चर्च का जन्मदिन, विश्वव्यापी मिशन की शुरुआत!"
      }
    },

    55: {
      name: "पतरस का पहला उपदेश",
      challenge: "हे भाइयों, हम क्या करें? पश्चाताप करो...",
      easy: {
        question: "पतरस के उपदेश के बाद कितने लोगों ने बपतिस्मा लिया?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "तीन हजार आत्माएं",
        funFact: "🌊 एक दिन में 3000 बपतिस्मे - असाधारण आध्यात्मिक जागृति!"
      },
      medium: {
        question: "पतरस ने भीड़ पर क्या आरोप लगाया?",
        options: [
          "अज्ञानता का",
          "यीशु मसीह को क्रूस पर चढ़ाने का",
          "विश्वास की कमी का",
          "पाखंड का"
        ],
        hint: "परमेश्वर के पुत्र के विरुद्ध सर्वोच्च अपराध",
        funFact: "⚔️ पतरस, जिसने यीशु का इनकार किया था, अब उनकी दिव्यता की घोषणा करता है!"
      },
      hard: {
        question: "पतरस का परिवर्तन पवित्र आत्मा के कार्य को कैसे दर्शाता है?",
        options: [
          "वह अधिक शिक्षित हो जाता है",
          "कायर और अस्थिर से, वह विश्वास में साहसी और दृढ़ बन जाता है",
          "उसे शक्तियां मिलती हैं",
          "उसका व्यक्तित्व बदल जाता है"
        ],
        hint: "यह आत्मा द्वारा पवित्रीकरण के बारे में है",
        funFact: "🗿 'हिलता नरकट' 'मजबूत चट्टान' बन जाता है - परिवर्तनकारी शक्ति!"
      }
    },

    56: {
      name: "पहला समुदाय",
      challenge: "वे प्रेरितों के उपदेश और संगति में लगे रहे...",
      easy: {
        question: "पहले मसीहियों ने अपनी संपत्ति कैसे साझा की?",
        options: [
          "हर कोई अपना रखता था",
          "उनके पास सब कुछ समान था",
          "केवल अमीर देते थे",
          "कानूनी दायित्व द्वारा"
        ],
        hint: "स्वैच्छिक संपत्ति समुदाय",
        funFact: "🤝 भाईचारे का प्यार इतना तीव्र कि वे स्वतः सब कुछ साझा करते हैं!"
      },
      medium: {
        question: "पहले मसीहियों ने अपना समय किसमें लगाया?",
        options: [
          "केवल व्यापार में",
          "शिक्षा, संगति, रोटी तोड़ना, प्रार्थना",
          "केवल काम में",
          "मनोरंजन में"
        ],
        hint: "सामुदायिक जीवन के चार स्तंभ",
        funFact: "⛪ शिक्षा, संगति, यूखरिस्त, प्रार्थना - चर्च की नींव!"
      },
      hard: {
        question: "यह पहला समुदाय इतना आकर्षक क्यों था?",
        options: [
          "यह धनी था",
          "प्रामाणिक प्रेम और आनंद उनकी एकता से चमकते थे",
          "इसने चमत्कारों का वादा किया",
          "इसने दूसरों की आलोचना की"
        ],
        hint: "यह जीवित प्रेम की गवाही के बारे में है",
        funFact: "✨ 'देखो वे एक दूसरे से कैसे प्यार करते हैं!' - शब्दों से अधिक विश्वास दिलाने वाली गवाही!"
      }
    },

    57: {
      name: "लंगड़े की चंगाई",
      challenge: "चांदी और सोना तो मेरे पास नहीं; पर जो मेरे पास है वह तुझे देता हूं...",
      easy: {
        question: "वह आदमी कब से लंगड़ा था?",
        options: [
          "20 साल से",
          "30 साल से", 
          "जन्म से",
          "10 साल से"
        ],
        hint: "हमेशा से विकलांगता",
        funFact: "🚶 40 साल की विकलांगता यीशु के नाम पर तुरंत चंगी हो गई!"
      },
      medium: {
        question: "पतरस ने लंगड़े को किसके नाम पर चंगा किया?",
        options: [
          "परमेश्वर के नाम पर",
          "नासरत के यीशु मसीह के नाम पर",
          "अपने नाम पर",
          "अब्राहम के नाम पर"
        ],
        hint: "वह नाम जो सब नामों से ऊपर है",
        funFact: "✊ यीशु का नाम प्रेरितों के माध्यम से चमत्कार करना जारी रखता है!"
      },
      hard: {
        question: "यह चंगाई सुसमाचार के लिए क्या प्रतीक है?",
        options: [
          "एक साधारण चिकित्सा चमत्कार",
          "पूर्ण उद्धार जो यीशु लाते हैं: आध्यात्मिक और शारीरिक",
          "प्रेरितों की शक्ति",
          "गरीबों के लिए दान"
        ],
        hint: "यह मनुष्य के पूर्ण उद्धार के बारे में है",
        funFact: "🩺 यीशु आत्मा और शरीर दोनों को चंगा करते हैं - व्यक्ति का संपूर्ण उद्धार!"
      }
    },

    58: {
      name: "उत्पीड़न शुरू होता है",
      challenge: "मनुष्यों की आज्ञा की अपेक्षा परमेश्वर की आज्ञा का पालन करना उचित है...",
      easy: {
        question: "लंगड़े की चंगाई के बाद पतरस और यूहन्ना को किसने गिरफ्तार किया?",
        options: [
          "रोमियों ने",
          "सदूकियों और याजकों ने",
          "लोगों ने",
          "पिलातुस ने"
        ],
        hint: "यहूदी धार्मिक अधिकारियों ने",
        funFact: "⛓️ पहला धार्मिक उत्पीड़न - सुसमाचार स्थापना को परेशान करता है!"
      },
      medium: {
        question: "अधिकारियों ने प्रेरितों को क्या मना किया?",
        options: [
          "यरूशलेम छोड़ने को",
          "यीशु के नाम पर और शिक्षा न देने को",
          "और चमत्कार न करने को",
          "और प्रार्थना न करने को"
        ],
        hint: "प्रचार करने की मनाही",
        funFact: "🚫 सच्चाई को चुप कराने का प्रयास - सुसमाचार को रोकना असंभव है!"
      },
      hard: {
        question: "प्रेरितों ने मनाही पर कैसे प्रतिक्रिया दी?",
        options: [
          "उन्होंने डर से आज्ञा मानी",
          "उन्होंने कहा कि मनुष्यों से अधिक परमेश्वर की आज्ञा माननी चाहिए",
          "उन्होंने बातचीत की",
          "वे भाग गए"
        ],
        hint: "यह मानवीय कानूनों से ऊंची निष्ठा के बारे में है",
        funFact: "⚖️ परमेश्वर की आज्ञा मानने के लिए नागरिक अवज्ञा - विश्वास का साहस!"
      }
    },

    59: {
      name: "हनन्याह और सफीरा",
      challenge: "तूने मनुष्यों से नहीं परन्तु परमेश्वर से झूठ बोला है...",
      easy: {
        question: "हनन्याह और सफीरा ने क्या झूठ बोला?",
        options: [
          "उन्होंने कुछ नहीं बेचा था",
          "उन्होंने पूरी कीमत दी जबकि कुछ रख लिया था",
          "वे गरीब थे",
          "वे विवाहित नहीं थे"
        ],
        hint: "दी गई राशि के बारे में झूठ",
        funFact: "💰 कुछ रखना अनुमत था, दान के बारे में झूठ बोलना नहीं!"
      },
      medium: {
        question: "उनके झूठ के बाद उन्हें क्या हुआ?",
        options: [
          "उन्हें क्षमा कर दिया गया",
          "वे अचानक मर गए",
          "उन्हें निकाल दिया गया",
          "उन्होंने पश्चाताप किया"
        ],
        hint: "तत्काल और कठोर सजा",
        funFact: "⚱️ नवजात चर्च की शुद्धता बनाए रखने के लिए कठोर न्याय!"
      },
      hard: {
        question: "चर्च की शुरुआत में इतनी कठोर सजा क्यों?",
        options: [
          "परमेश्वर क्रूर थे",
          "समुदाय में आवश्यक पवित्रता स्थापित करने के लिए",
          "डराने के लिए",
          "संयोग से"
        ],
        hint: "यह आध्यात्मिक अखंडता बनाए रखने के बारे में है",
        funFact: "🔥 पवित्रता की संस्कृति स्थापित करने के लिए शुरुआत में उच्च मानक!"
      }
    },

    60: {
      name: "सात डीकन",
      challenge: "अपने में से सात सुनाम पुरुषों को चुन लो...",
      easy: {
        question: "कितने डीकन चुने गए?",
        options: ["5", "6", "7", "12"],
        hint: "पूर्णता की संख्या",
        funFact: "7️⃣ सेवा के लिए सात डीकन - चर्च का दैवीय संगठन!"
      },
      medium: {
        question: "उनकी मुख्य भूमिका क्या थी?",
        options: [
          "सुसमाचार प्रचार करना",
          "मेजों पर सेवा करना और विधवाओं की मदद करना",
          "नए विश्वासियों को बपतिस्मा देना",
          "वित्त प्रबंधन करना"
        ],
        hint: "सामाजिक और भौतिक सेवा",
        funFact: "🍽️ मेज सेवा = पहला मसीही दान संगठन!"
      },
      hard: {
        question: "यह संगठन सेवा के मसीही दृष्टिकोण के बारे में क्या प्रकट करता है?",
        options: [
          "भौतिक कार्य हीन हैं",
          "आध्यात्मिक और भौतिक सेवा दोनों पवित्र हैं",
          "पवित्र को सांसारिक से अलग करना होगा",
          "केवल याजक वास्तव में सेवा करते हैं"
        ],
        hint: "यह हर प्रेम सेवा की पवित्रता के बारे में है",
        funFact: "✨ प्रचार करने जितनी ही गरिमा से मेजों पर सेवा - हर सेवा पवित्र है!"
      }
    },

    61: {
      name: "स्तिफनुस, पहला शहीद",
      challenge: "हे प्रभु, यह पाप उन पर मत लगा! यह कहकर सो गया...",
      easy: {
        question: "चर्च में स्तिफनुस का क्या कार्य था?",
        options: ["प्रेरित", "डीकन", "याजक", "भविष्यवक्ता"],
        hint: "सेवा के लिए चुने गए सात में से एक",
        funFact: "✨ स्तिफनुस: डीकन शक्तिशाली प्रचारक और पहला शहीद बन गया!"
      },
      medium: {
        question: "स्तिफनुस ने यहूदी नेताओं पर क्या आरोप लगाया?",
        options: [
          "भ्रष्टाचार का",
          "पवित्र आत्मा का हमेशा विरोध करने का",
          "पाखंड का",
          "लालच का"
        ],
        hint: "परमेश्वर के विरुद्ध ऐतिहासिक प्रतिरोध",
        funFact: "📜 स्तिफनुस इतिहास सारांशित करता है: परमेश्वर के विरुद्ध निरंतर विद्रोह!"
      },
      hard: {
        question: "स्तिफनुस कैसे मरा और उसका रवैया क्या प्रकट करता है?",
        options: [
          "अपने हत्यारों के प्रति क्रोध में",
          "क्रूस पर यीशु की तरह क्षमा करते हुए",
          "निराशा में",
          "अपने शत्रुओं को शाप देते हुए"
        ],
        hint: "यह मसीह की पूर्ण नकल के बारे में है",
        funFact: "💝 हत्यारों की क्षमा: स्तिफनुस यीशु के रवैये को पूर्णतः पुनः प्रस्तुत करता है!"
      }
    },

    62: {
      name: "फिलिप्पुस और इथियोपियाई खोजा",
      challenge: "यदि कोई मुझे न समझाए तो मैं कैसे समझूं?",
      easy: {
        question: "खोजा अपने रथ में क्या पढ़ रहा था?",
        options: [
          "भजन संहिता",
          "यशायाह भविष्यवक्ता",
          "उत्पत्ति",
          "नीतिवचन"
        ],
        hint: "मसीह के दुःख का भविष्यवक्ता",
        funFact: "📖 यशायाह 53 - यीशु की सही भविष्यवाणी जिसे एक सच्चे खोजी ने पढ़ा!"
      },
      medium: {
        question: "फिलिप्पुस ने यशायाह के अंश को कैसे समझाया?",
        options: [
          "उसने प्राचीन इतिहास के बारे में बात की",
          "उसने इस पाठ से यीशु का प्रचार किया",
          "उसने धर्मशास्त्र का पाठ दिया",
          "उसने व्याख्याओं की आलोचना की"
        ],
        hint: "शास्त्र स्वाभाविक रूप से मसीह की ओर ले जाता है",
        funFact: "✝️ सारा शास्त्र यीशु की ओर अभिसरण करता है - समझ की कुंजी!"
      },
      hard: {
        question: "इथियोपियाई खोजे का परिवर्तन क्या प्रतीक है?",
        options: [
          "एक अलग परिवर्तन",
          "सभी जातियों और स्थितियों के लिए सुसमाचार की सार्वभौमिकता",
          "कुछ लोगों की श्रेष्ठता",
          "एक विशेष मामला"
        ],
        hint: "यह राष्ट्रों के लिए खुलेपन के बारे में है",
        funFact: "🌍 इथियोपियाई, खोजा, मंत्री: सुसमाचार सभी बाधाओं को तोड़ता है!"
      }
    },

    63: {
      name: "तरसुस के शाऊल का परिवर्तन",
      challenge: "शाऊल, शाऊल, तू मुझे क्यों सताता है?",
      easy: {
        question: "अपने परिवर्तन से पहले शाऊल क्या कर रहा था?",
        options: [
          "वह सुसमाचार प्रचार कर रहा था",
          "वह मसीहियों को सता रहा था",
          "वह तटस्थ था",
          "वह केवल अध्ययन कर रहा था"
        ],
        hint: "शिष्यों का कट्टर शत्रु",
        funFact: "⚔️ शाऊल यीशु के शिष्यों के विरुद्ध धमकी और हत्या की सांस ले रहा था!"
      },
      medium: {
        question: "यीशु शाऊल को किस रास्ते पर दिखाई दिए?",
        options: [
          "यरूशलेम का रास्ता",
          "दमिश्क का रास्ता",
          "गाजा का रास्ता",
          "अन्ताकिया का रास्ता"
        ],
        hint: "सीरिया का एक शहर",
        funFact: "🛤️ दमिश्क का रास्ता = इतिहास में परिवर्तन का सबसे प्रसिद्ध स्थान!"
      },
      hard: {
        question: "यह परिवर्तन दैवीय अनुग्रह को कैसे दर्शाता है?",
        options: [
          "परमेश्वर केवल अच्छे लोगों को परिवर्तित करते हैं",
          "अनुग्रह सबसे बुरे शत्रु को सबसे बड़े प्रेरित में बदल सकता है",
          "परिवर्तन योग्य था",
          "शाऊल पहले से ही परमेश्वर के करीब था"
        ],
        hint: "यह अनुग्रह की परिवर्तनकारी शक्ति के बारे में है",
        funFact: "⚡ सबसे बड़े उत्पीड़क से सबसे बड़े मिशनरी तक - अनुग्रह का चमत्कार!"
      }
    },

    64: {
      name: "पतरस और कुरनेलियुस",
      challenge: "सचमुच मैं समझ गया कि परमेश्वर किसी का पक्षपात नहीं करता...",
      easy: {
        question: "कुरनेलियुस का व्यवसाय क्या था?",
        options: [
          "व्यापारी",
          "रोमी सूबेदार",
          "याजक",
          "शास्त्री"
        ],
        hint: "रोमी सेना का अधिकारी",
        funFact: "🎖️ आधिकारिक रूप से परिवर्तित पहला गैर-यहूदी - गैर-यहूदियों के लिए खुलापन!"
      },
      medium: {
        question: "कुरनेलियुस से मिलने से पहले पतरस ने क्या दर्शन देखा?",
        options: [
          "एक स्वर्गदूत उससे बात कर रहा था",
          "शुद्ध और अशुद्ध पशुओं के साथ एक चादर",
          "यीशु उसे दिखाई दे रहे थे",
          "एक नष्ट मंदिर"
        ],
        hint: "शुद्धता और अशुद्धता पर दर्शन",
        funFact: "🕊️ पशुओं के साथ चादर: परमेश्वर आहार और जातीय भेदभाव समाप्त करते हैं!"
      },
      hard: {
        question: "इस परिवर्तन ने कौन सा क्रांतिकारी सिद्धांत स्थापित किया?",
        options: [
          "रोमी श्रेष्ठ हैं",
          "परमेश्वर किसी का पक्षपात नहीं करता - सार्वभौमिक उद्धार",
          "परंपराओं को त्यागना होगा",
          "खतना बेकार है"
        ],
        hint: "यह उद्धार की सार्वभौमिकता के बारे में है",
        funFact: "🌍 आध्यात्मिक क्रांति: सुसमाचार बिना किसी अपवाद के सभी लोगों के लिए है!"
      }
    },

    65: {
      name: "अन्ताकिया का चर्च",
      challenge: "अन्ताकिया में शिष्य पहली बार मसीही कहलाए...",
      easy: {
        question: "अन्ताकिया में शिष्यों को पहली बार क्या कहा गया?",
        options: ["शिष्य", "मसीही", "विश्वासी", "संत"],
        hint: "वह नाम जो हम आज भी धारण करते हैं",
        funFact: "✝️ 'मसीही' = 'छोटे मसीह' - अन्यजातियों द्वारा दिया गया सम्मान का नाम!"
      },
      medium: {
        question: "बरनबास के साथ अन्ताकिया में पढ़ाने कौन आया?",
        options: [
          "पतरस",
          "पौलुस (शाऊल)",
          "याकूब",
          "यूहन्ना"
        ],
        hint: "पूर्व उत्पीड़क जो प्रेरित बन गया",
        funFact: "👥 बरनबास तरसुस में पौलुस को खोजता है - पौलुस की सेवकाई की शुरुआत!"
      },
      hard: {
        question: "अन्ताकिया मसीही इतिहास में इतना महत्वपूर्ण क्यों बना?",
        options: [
          "यह धनी था",
          "अन्यजातियों के लिए पहला मिशनरी केंद्र",
          "यह अच्छी तरह से स्थित था",
          "इसके अच्छे नेता थे"
        ],
        hint: "यह मिशनरी विस्तार के बारे में है",
        funFact: "🚢 अन्ताकिया: यूरोप के लिए पौलुस की सभी मिशन यात्राओं का प्रक्षेपण बंदरगाह!"
      }
    }
  }
};

export default chapter5Translations;
